import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ToastService} from './toast-service';

import {SwiperComponent, SwiperDirective} from 'ngx-swiper-wrapper';
import {environment} from "../../../../environments/environment";
import {UtilityService} from "../../../core/services/utility.service";
import {ToastrService} from "ngx-toastr";
import {ResumenGraficos} from "../../../core/models/resumen.graficos.model";

import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Operador} from "../../../core/models/operador.model";
import {takeUntil, tap} from "rxjs/operators";
import {SharedService} from "../../../core/services/shared.service";
import {Subject} from "rxjs";
import {UserService} from "../../../core/services/user.service";
import {TYPE_OPERACION, TYPE_USER} from "../../../core/models/constants";
import {Router} from "@angular/router";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

/**
 * Ecommerce Component
 */
export class DashboardComponent implements OnInit, OnDestroy {

  // bread crumb items
  breadCrumbItems!: Array<{}>;

  statData!: any;
  updatingDonutChart: any;
  distributedColumnChart: any;

  // Paleta moderna para todos los gráficos
  public palettModern = ['#2c7be5', '#27ae60', '#f39c12', '#17a2b8', '#e74c3c', '#8e44ad', '#5a6acf', '#00b8a9', '#fd7e62'];

  public CDN_BASE = environment.CDN_BASE;
  public HTTP_RESPONSE = environment.HTTP_RESPONSE;
  public PARAM = environment.PARAM;

  public usuarioLogeado: any = null;
  public dataTotalesDashboard: any = null;
  public graficoTopOperador: any = null;
  public graficoTopClienteData: any = null;
  public graficoTipoContenedor: any = null;
  public graficoTipoEmbarque: any = null;
  public mostrarModalClasificacionCliente = false;
  public listaClasificacionClientesByOperador: any[] = [];
  public listaOtrosExportadores: any[] = [];
  public isLoadingOtrosModal = false;
  // True when the operator logo image fails to load (404 / broken CDN path),
  // so the hero section can fall back to a generic building icon + initials.
  public logoLoadError = false;
  localList: any[] = [];
  isLoading = false;
  text_button = "Aceptar";

  // Loading por gráfico
  isLoadingChartOperaciones = false;
  isLoadingChartTopCliente = false;
  isLoadingChartTipoContenedor = false;
  isLoadingChartTipoEmbarque = false;

  // Empty state por gráfico
  emptyChartOperaciones = false;
  emptyChartTopCliente = false;
  emptyChartTipoContenedor = false;
  emptyChartTipoEmbarque = false;

  tipoEmbarquesNames = '';

  public TYPE_OPERACION = TYPE_OPERACION;
  public registrosClasificacion = 10;
  public urlDescargableEECC = null;
  public token: any;
  year = this.utilityService.obtenerAnioActual().toString();
  public mesOperacionesPorAnioSeleccionado = new Date().getMonth() + 1;
  mesesList: any[] = [];
  aceptoTerminosCondiciones = this.PARAM.NO;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  public filtros: any = {};
  enabledCountTO = false;
  TYPE_USER = TYPE_USER;
  totalRegistrosClasificacion = 0;
  tipoOpereacionList = this.utilityService.getTipoOperaciones();

  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  @ViewChild('modalTerminosCondiciones') modalTerminosCondiciones!: TemplateRef<any>;
  @ViewChild('modalOtrosExportadores') modalOtrosExportadores!: TemplateRef<any>;


    constructor(public toastService: ToastService,
              public utilityService: UtilityService, private toastrService: ToastrService,public sharedService: SharedService,
              public resumenGraficos: ResumenGraficos, private modalService: NgbModal, private operador: Operador,
              public user: UserService, private router: Router) { }

  async ngOnInit() {
    /**
     * BreadCrumb
     */
     this.breadCrumbItems = [
      { label: 'Dashboards' },
      { label: 'Dashboard', active: true }
    ];

    this.filtros.localid = this.PARAM.TODOS;
    this.filtros.mes = this.mesOperacionesPorAnioSeleccionado;
    this.filtros.anio = this.year;
    this.filtros.tipo = this.tipoOpereacionList[0].id;


    this.token = await this.user.userToken;

      if(!this.user.termsConditions){
        setTimeout(() => {
            this.openModalTerminosCondiciones();
        },1000);

    }

      this.mesesList = this.utilityService.obtenerListaMeses();
      if(this.mesesList.length > 0){
          this.mesesList.push({
              label: "General",
              value: this.PARAM.TODOS
          })
      }

      this.sharedService._dataSharedLocalList.pipe(
          takeUntil(this._unsubscribeAll),
          tap(data => {
             this.setLocales(data);
          }),
      ).subscribe();


      this.filtrarInformacionDashboard();

      this.getEstadoCuentaActualOperador();




  }

  private setLocales(data: any){
      this.localList = data;
  }

  public incremetYear(){
    this.filtros.anio++;
    this.filtrarInformacionDashboard();
  }

  public decrementYear(){
      this.filtros.anio--;
      this.filtrarInformacionDashboard();
  }

  public filtrarInformacionDashboard(){
    this.getTotalesDashboard();
    this.getGraficoTopCliente();
    this.getGraficoOperaciones();
    this.getGraficoMovimientosPorTipoContenedor();
    this.getGraficoMovimientosPorTipoEmbarque();
  }

  public openModalTerminosCondiciones(){
      this.modalService.open(this.modalTerminosCondiciones, { size: 'xl', centered: true, scrollable: true, backdrop: 'static', keyboard: false });
  }

  private getObjEnvioDashboard(){

       return {
           local: this.filtros.localid,
           month: this.filtros.mes,
           year: this.filtros.anio,
           tipo: this.filtros.tipo,
       }
  }

    public getTotalesDashboard() {
        this.enabledCountTO = false;
        var objEnvio = this.getObjEnvioDashboard();
        this.dataTotalesDashboard = {};

        setTimeout (() => {
            this.enabledCountTO = true;
        }, 100);


        this.resumenGraficos.getTotalesDashboard(objEnvio).then((response: any) => {

            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                this.dataTotalesDashboard = response.data
            } else if(response.tipo == this.HTTP_RESPONSE.ERROR) {
                this.toastrService.error('Ocurrio un problemas al obtener los datos totales por operador');
            }
        })
    }



    public getGraficoTopCliente() {
        this.isLoadingChartTopCliente = true;
        this.emptyChartTopCliente = false;
        var objEnvio = this.getObjEnvioDashboard();
        this.resumenGraficos.getGraficoTopCliente(objEnvio).then((response: any) => {
            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                const data = response.data;
                if (!data.series || data.series.length === 0 || data.series.every((s: any) => s === 0)) {
                    this.emptyChartTopCliente = true;
                } else {
                    this.dibujarGraficoTopCliente(data);
                    this.graficoTopClienteData = data;
                }
            } else if(response.tipo == this.HTTP_RESPONSE.ERROR) {
                this.emptyChartTopCliente = true;
                this.toastrService.error('Ocurrio un problemas al obtener los datos de el grafico top clientes por operador');
            }
            this.isLoadingChartTopCliente = false;
        })
    }

    public getGraficoOperaciones() {
        this.isLoadingChartOperaciones = true;
        this.emptyChartOperaciones = false;
        var objEnvio = this.getObjEnvioDashboard();
        this.resumenGraficos.getGraficoOperacionesOperador(objEnvio).then((response: any) => {
            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                const data = response.data;
                const hasData = data.series && data.series.length > 0 &&
                    data.series.some((s: any) => s.data && s.data.some((v: any) => v > 0));
                if (!hasData) {
                    this.emptyChartOperaciones = true;
                } else {
                    this.dibujarGraficoOperaciones(data);
                    this.graficoTopOperador = data;
                }
            } else if(response.tipo == this.HTTP_RESPONSE.ERROR) {
                this.emptyChartOperaciones = true;
                this.toastrService.error('Ocurrio un problemas al obtener los datos de el grafico top clientes por operador');
            }
            this.isLoadingChartOperaciones = false;
        })
    }

    public seleccionarMesOperacion(mes: number){
      this.mesOperacionesPorAnioSeleccionado = mes;
      this.getGraficoOperaciones();
    }

    // Suffixes to strip from exporter names
    private readonly BUSINESS_SUFFIXES = [
        'S.C.R.L.', 'S.A.C.', 'S.A.A.', 'S.R.L.', 'S.A.',
        'SCRL', 'EIRL', 'SAA', 'S.A.C', 'SAC', 'SRL', 'LTDA', 'CIA', 'CORP', 'SA'
    ];

    /**
     * Triggered by the hero logo <img> (error) event when the operator's
     * logo can't be loaded (missing file, broken CDN path, 404, etc.).
     * Switches the template to the fallback building-icon + initials avatar.
     */
    public onLogoError(): void {
        this.logoLoadError = true;
    }

    /**
     * Builds a 2-letter initials avatar text from the operator name,
     * used as a fallback when there's no logo or it fails to load.
     */
    public getOperadorInitials(name?: string): string {
        if (!name) return 'OP';
        const words = name.trim().split(/\s+/).filter(Boolean);
        if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    public removeSuffix(name: string): string {
        if (!name) return '';
        let n = name.trim();
        for (const sfx of this.BUSINESS_SUFFIXES) {
            const escaped = sfx.replace(/\./g, '\\.');
            const regex = new RegExp('[\\s,\\-–]*' + escaped + '[\\s.]*$', 'i');
            if (regex.test(n)) {
                n = n.replace(regex, '').trim().replace(/[,\s]+$/, '');
                break;
            }
        }
        return n.trim();
    }

    private splitLabel(name: string, maxLen: number = 20): string | string[] {
        if (!name || name.length <= maxLen) return name;
        const words = name.split(' ');
        if (words.length <= 1) return name;
        const mid = Math.ceil(words.length / 2);
        return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
    }

    private dibujarGraficoTopCliente(datachart: any) {
        const self = this;
        const rawLabels: string[] = datachart.labels || [];
        const series: number[] = datachart.series || [];

        // Strip suffixes and build display labels (may be arrays for multi-line)
        const displayLabels = rawLabels.map((l: string) =>
            l === 'OTROS' ? l : self.splitLabel(self.removeSuffix(l))
        );

        this.updatingDonutChart = {
            series: [{ name: 'N° Contenedores', data: series }],
            chart: {
                type: 'bar',
                height: '100%',
                parentHeightOffset: 0,
                toolbar: {
                    show: true,
                    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
                    export: {
                        csv: { filename: 'top-exportadores' },
                        svg: { filename: 'top-exportadores' },
                        png: { filename: 'top-exportadores' }
                    }
                },
                animations: { enabled: true, easing: 'easeinout', speed: 600 },
                events: {
                    dataPointSelection: function(event: any, chartContext: any, config: any) {
                        const label = rawLabels[config.dataPointIndex];
                        if (label === 'OTROS') {
                            self.openModalOtrosExportadores();
                        }
                    }
                }
            },
            states: {
                hover: { filter: { type: 'darken', value: 0.85 } },
                active: { filter: { type: 'darken', value: 0.75 } }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: true,
                    borderRadius: 5,
                    barHeight: '60%',
                    dataLabels: { position: 'top' },
                }
            },
            dataLabels: {
                enabled: true,
                offsetX: 28,
                style: { colors: ['#495057'], fontSize: '11px', fontWeight: 600 }
            },
            xaxis: {
                categories: displayLabels,
                title: {
                    text: 'N° Contenedores',
                    style: { color: '#9aa0ac', fontSize: '11px', fontWeight: 400 }
                },
                labels: {
                    formatter: (val: any) => Math.round(Number(val)).toString(),
                    style: { colors: '#9aa0ac', fontSize: '11px' }
                },
                axisBorder: { show: false },
                axisTicks: { show: false }
            },
            yaxis: {
                labels: {
                    maxWidth: 220,
                    style: { fontSize: '11px', colors: '#495057' }
                }
            },
            colors: rawLabels.map((label: string, i: number) =>
                label === 'OTROS' ? '#6c757d' : self.palettModern[i % self.palettModern.length]
            ),
            grid: {
                borderColor: '#f1f1f1',
                xaxis: { lines: { show: true } },
                yaxis: { lines: { show: false } }
            },
            tooltip: {
                y: {
                    formatter: (val: number, opts: any) => {
                        const rawLabel = rawLabels[opts.dataPointIndex];
                        return rawLabel === 'OTROS'
                            ? val + ' (click para ver detalle)'
                            : val + ' ';
                    }
                }
            },
            legend: { show: false },
            // Responsive breakpoints: on narrow containers the fixed yaxis label
            // width + dataLabels offset squeeze the bars to almost nothing, so we
            // scale labels/offsets/toolbar down progressively instead of using
            // fixed pixel values everywhere.
            responsive: [
                {
                    breakpoint: 992,
                    options: {
                        chart: { toolbar: { show: false } },
                        plotOptions: { bar: { barHeight: '55%' } },
                        dataLabels: { offsetX: 20, style: { fontSize: '10px' } },
                        yaxis: { labels: { maxWidth: 140, style: { fontSize: '10px' } } },
                        xaxis: { labels: { style: { fontSize: '10px' } } }
                    }
                },
                {
                    breakpoint: 576,
                    options: {
                        plotOptions: { bar: { barHeight: '50%', borderRadius: 3 } },
                        dataLabels: { offsetX: 14, style: { fontSize: '9px' } },
                        yaxis: { labels: { maxWidth: 90, style: { fontSize: '9px' } } },
                        xaxis: { labels: { style: { fontSize: '9px' } } }
                    }
                }
            ]
        };
    }

    private dibujarGraficoOperaciones(datachart: any) {
        const categories = datachart.categories || [];
        const rawSeries = datachart.series || [];
        const esPorMes = this.filtros.mes == -1 || this.filtros.mes == '-1';
        const xAxisTitle = esPorMes ? 'Mes' : 'Semana';

        // First series as area (with fill), rest as line — inspired by lineAreaChart (MixedComponent)
        const series = rawSeries.map((s: any, i: number) => ({ ...s, type: i === 0 ? 'area' : 'line' }));
        const fillOpacities = rawSeries.map((_: any, i: number) => i === 0 ? 0.3 : 1);
        const strokeWidths = rawSeries.map(() => 2.5);

        this.distributedColumnChart = {
            series,
            chart: {
                type: 'line',
                height: '100%',
                parentHeightOffset: 0,
                toolbar: {
                    show: true,
                    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
                    export: {
                        csv: { filename: 'operaciones-por-periodo' },
                        svg: { filename: 'operaciones-por-periodo' },
                        png: { filename: 'operaciones-por-periodo' }
                    }
                },
                zoom: { enabled: false },
                animations: { enabled: true, easing: 'easeinout', speed: 800 }
            },
            colors: this.palettModern.slice(0, rawSeries.length),
            stroke: { curve: 'smooth', width: strokeWidths },
            fill: { type: 'solid', opacity: fillOpacities },
            dataLabels: { enabled: false },
            markers: { size: 4, strokeColors: '#fff', strokeWidth: 2, hover: { size: 7 } },
            xaxis: {
                categories,
                title: { text: xAxisTitle, style: { color: '#9aa0ac', fontSize: '11px', fontWeight: 400 } },
                labels: { style: { colors: '#9aa0ac', fontSize: '12px' } },
                axisBorder: { show: false },
                axisTicks: { show: false }
            },
            yaxis: {
                labels: {
                    style: { colors: '#9aa0ac', fontSize: '12px' },
                    formatter: (val: number) => Math.round(val).toString()
                },
                title: { text: 'N° Contenedores', style: { color: '#9aa0ac', fontSize: '11px', fontWeight: 400 } }
            },
            grid: { borderColor: '#f1f1f1', strokeDashArray: 4, yaxis: { lines: { show: true } } },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'left',
                fontSize: '12px',
                markers: { width: 10, height: 10, radius: 3 }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: { formatter: (val: number) => val + ' cont.' }
            }
        };
    }

    public getGraficoMovimientosPorTipoContenedor() {
        this.isLoadingChartTipoContenedor = true;
        this.emptyChartTipoContenedor = false;
        const objEnvio = this.getObjEnvioDashboard();
        this.resumenGraficos.getGraficoMovimientosPorTipoContenedor(objEnvio).then((response: any) => {
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                const data = response.data;
                const tiposContenedores = response.tiposcontenedores || [];
                if (!data || data.length === 0) {
                    this.emptyChartTipoContenedor = true;
                } else {
                    this.dibujarGraficoTipoContenedor(data, tiposContenedores);
                }
            } else {
                this.emptyChartTipoContenedor = true;
            }
            this.isLoadingChartTipoContenedor = false;
        });
    }

    public getGraficoMovimientosPorTipoEmbarque() {
        this.isLoadingChartTipoEmbarque = true;
        this.emptyChartTipoEmbarque = false;
        const objEnvio = this.getObjEnvioDashboard();
        this.resumenGraficos.getGraficoMovimientosPorTipoEmbarque(objEnvio).then((response: any) => {
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                const data = response.data;
                const tiposEmbarque = response.tiposEmbarque || [];
                this.tipoEmbarquesNames = tiposEmbarque.map((item: { name: any; }) => item .name).join(', ');
                if (!data || data.length === 0) {
                    this.emptyChartTipoEmbarque = true;
                } else {
                    this.dibujarGraficoTipoEmbarque(data, tiposEmbarque);
                }
            } else {
                this.emptyChartTipoEmbarque = true;
            }
            this.isLoadingChartTipoEmbarque = false;
        });
    }

    private dibujarGraficoTipoContenedor(dataArray: any[], tiposContenedores: any[]) {
        const categories = dataArray.map((d: any) => d.periodo);
        const series = tiposContenedores.map((tc: any) => ({
            name: tc.name,
            data: dataArray.map((d: any) => d[tc.valueField] || 0)
        }));
        const execColors = ['#2c7be5', '#27ae60', '#f39c12', '#e74c3c', '#8e44ad', '#17a2b8'];

        this.graficoTipoContenedor = {
            series,
            chart: {
                type: 'bar',
                height: '100%',
                parentHeightOffset: 0,
                stacked: true,
                toolbar: {
                    show: true,
                    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
                    export: {
                        csv: { filename: 'tipo-contenedor' },
                        svg: { filename: 'tipo-contenedor' },
                        png: { filename: 'tipo-contenedor' }
                    }
                }
            },
            colors: execColors.slice(0, tiposContenedores.length),
            plotOptions: {
                bar: {
                    borderRadius: 3,
                    columnWidth: '60%',
                    dataLabels: { total: { enabled: true, style: { fontSize: '11px', fontWeight: 700, color: '#495057' } } }
                }
            },
            dataLabels: { enabled: false },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    type: 'vertical',
                    shadeIntensity: 0.15,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 0.82,
                    stops: [0, 100]
                }
            },
            xaxis: {
                categories,
                labels: { style: { colors: '#9aa0ac', fontSize: '11px' } },
                axisBorder: { show: false },
                axisTicks: { show: false }
            },
            yaxis: {
                labels: { style: { colors: '#9aa0ac', fontSize: '11px' }, formatter: (v: number) => Math.round(v).toString() },
                title: { text: 'N° Contenedores', style: { color: '#9aa0ac', fontSize: '11px', fontWeight: 400 } }
            },
            legend: { show: true, position: 'top', horizontalAlign: 'left', fontSize: '12px', markers: { width: 10, height: 10, radius: 3 } },
            grid: { borderColor: '#f1f1f1', strokeDashArray: 4, yaxis: { lines: { show: true } } },
            tooltip: {
                shared: true,
                intersect: false,
                y: { formatter: (v: number) => v + ' contenedores' }
            }
        };
    }

    private dibujarGraficoTipoEmbarque(dataArray: any[], tiposEmbarque: any[]) {
        const categories = dataArray.map((d: any) => d.periodo);
        const rawSeries = tiposEmbarque.map((te: any) => ({
            name: te.name,
            data: dataArray.map((d: any) => d[te.valueField] || 0)
        }));

        // Mixed area+line — inspired by lineAreaChart (MixedComponent): first = area, rest = line
        const series = rawSeries.map((s: any, i: number) => ({ ...s, type: i === 0 ? 'area' : 'line' }));
        const fillOpacities = rawSeries.map((_: any, i: number) => i === 0 ? 0.3 : 1);
        const execColors = ['#2c7be5', '#17a2b8', '#27ae60', '#e74c3c'];

        this.graficoTipoEmbarque = {
            series,
            chart: {
                type: 'line',
                height: '100%',
                parentHeightOffset: 0,
                stacked: false,
                toolbar: {
                    show: true,
                    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
                    export: {
                        csv: { filename: 'tipo-embarque' },
                        svg: { filename: 'tipo-embarque' },
                        png: { filename: 'tipo-embarque' }
                    }
                },
                animations: { enabled: true, easing: 'easeinout', speed: 800 }
            },
            colors: execColors.slice(0, tiposEmbarque.length),
            stroke: { curve: 'smooth', width: rawSeries.map(() => 2.5) },
            fill: { type: 'solid', opacity: fillOpacities },
            dataLabels: { enabled: false },
            markers: { size: 4, strokeColors: '#fff', strokeWidth: 2, hover: { size: 7 } },
            xaxis: {
                categories,
                labels: { style: { colors: '#9aa0ac', fontSize: '11px' } },
                axisBorder: { show: false },
                axisTicks: { show: false }
            },
            yaxis: {
                labels: { style: { colors: '#9aa0ac', fontSize: '11px' }, formatter: (v: number) => Math.round(v).toString() },
                title: { text: 'N° Contenedores', style: { color: '#9aa0ac', fontSize: '11px', fontWeight: 400 } }
            },
            legend: { show: true, position: 'top', horizontalAlign: 'left', fontSize: '12px', markers: { width: 10, height: 10, radius: 3 } },
            grid: { borderColor: '#f1f1f1', strokeDashArray: 4, yaxis: { lines: { show: true } } },
            tooltip: {
                shared: true,
                intersect: false,
                y: { formatter: (v: number) => v + ' contenedores' }
            }
        };
    }

  // Chart Colors Set
  private getChartColorsArray(colors:any) {
    colors = JSON.parse(colors);
    return colors.map(function (value:any) {
      var newValue = value.replace(" ", "");
      if (newValue.indexOf(",") === -1) {
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
            if (color) {
            color = color.replace(" ", "");
            return color;
            }
            else return newValue;;
        } else {
            var val = value.split(',');
            if (val.length == 2) {
                var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
                rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
                return rgbaColor;
            } else {
                return newValue;
            }
        }
    });
  }

  // Duración del CountTo según magnitud del valor
  public getCountDuration(value: number): number {
    if (!value || value === 0) return 0.5;
    if (value >= 10000) return 3;
    if (value >= 1000) return 2;
    if (value >= 100) return 1.5;
    return 1;
  }

  // Nivel visual del KPI (para clase CSS y color)
  public getCountLevel(value: number): string {
    if (!value || value === 0) return 'level-zero';
    if (value >= 1000) return 'level-high';
    if (value >= 100) return 'level-medium';
    return 'level-low';
  }

  // Abre modal de OTROS exportadores
  public openModalOtrosExportadores() {
    this.listaOtrosExportadores = [];
    this.modalService.open(this.modalOtrosExportadores, { size: 'lg', centered: true, scrollable: true });
    this.getDetalleClientesOtrosVisor();
  }

  public getDetalleClientesOtrosVisor() {
    this.isLoadingOtrosModal = true;
    const objEnvio = this.getObjEnvioDashboard();
    this.resumenGraficos.getDetalleClientesOtrosVisor(objEnvio).then((response: any) => {
      if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
        this.listaOtrosExportadores = response.data || [];
      } else {
        this.toastrService.error('No se pudo obtener el detalle de los clientes OTROS');
      }
      this.isLoadingOtrosModal = false;
    });
  }

  // Navegar a la ruta de OTROS exportadores
  public irAOtrosExportadores() {
    this.router.navigate(['/exportadores-otros'], { queryParams: this.getObjEnvioDashboard() });
  }


  /**
   * Recent Activity
   */
   toggleActivity() {
    const recentActivity = document.querySelector('.layout-rightside-col');
    if(recentActivity != null){
      recentActivity.classList.toggle('d-none');
    }

    if (window.screen.width <= 767) {
      const recentActivity = document.querySelector('.layout-rightside-col');
      if(recentActivity != null){
        recentActivity.classList.add('d-block');
        recentActivity.classList.remove('d-none');
      }
    }
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
   SidebarHide() {
    const recentActivity = document.querySelector('.layout-rightside-col');
      if(recentActivity != null){
        recentActivity.classList.remove('d-block');
      }
  }

  fnValorCheckTerminoCondiciones(){
       if(this.aceptoTerminosCondiciones == this.PARAM.NO){
           this.aceptoTerminosCondiciones = this.PARAM.SI;
       }else{
           this.aceptoTerminosCondiciones = this.PARAM.NO;
       }
  }

    fnAceptarTerminosCondiciones(){
       this.cargandoLoadingButton();
        this.operador.aceptarTerminosYCondiciones().then((response: any) => {
            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {

                this.user.setTermsConditions(response.data);
                this.modalService.dismissAll();


            } else {
                this.toastrService.error(response.mensajes);
            }

            this.eliminarLoadingButton();
        })
    }

    cargandoLoadingButton(){
        this.isLoading = true;
        this.text_button = "Aceptando Condiciones"
    }

    eliminarLoadingButton(){
        this.isLoading = false;
        this.text_button = "Aceptar"
    }


    public verCondicionesOperador() {
        if (this.usuarioLogeado && this.usuarioLogeado.operador && this.usuarioLogeado.operador.operador_urlcondiciones && this.usuarioLogeado.operador.operador_urlcondiciones != '') {
            window.open(this.CDN_BASE + this.usuarioLogeado.operador.operador_urlcondiciones, '_blank');
        } else {
            this.toastrService.error('No se encontraron condiciones para descargar');
        }
    }

    public getClasificacionClientesByOperador() {
       this.isLoading = true;
        var objEnvio = this.getObjEnvioDashboard();
        this.resumenGraficos.getClasificacionClientesByOperador(objEnvio).then((response: any) => {
            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                this.listaClasificacionClientesByOperador = response.data;
                this.listaOtrosExportadores = response.data;
                this.totalRegistrosClasificacion = this.listaClasificacionClientesByOperador.length;
            } else {
                this.toastrService.error('Ocurrio un problemas al obtener los datos de el grafico top clientes por operador');
            }
            this.isLoading = false;
        })
    }

    public abrilModalClasificacionClientes(content: any){
        this.modalService.open(content, { size: 'lg', centered: true, scrollable: true });
        this.listaClasificacionClientesByOperador.length = 0;
        this.getClasificacionClientesByOperador();
    }

    public getEstadoCuentaActualOperador() {
        this.resumenGraficos.getEstadoCuentaActualOperador().then((response: any) => {
            // @ts-ignore
            if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
                this.urlDescargableEECC = response.data.operadorcuenta_url;
            }
        })
    }

    public descargarEECC() {
        if (this.urlDescargableEECC) {
            window.open(this.CDN_BASE + this.urlDescargableEECC, '_blank');
        } else {
            this.toastrService.error('No se encontró E.E.C.C. para descargar');
        }
    }



    public descargarReporteClasificacionClientes() {

        var objEnvio = this.getObjEnvioDashboard();

        window.open(environment.CDN_BASE + "api/reports/report.php?type=excel&page=operador_reporteclasificacionclientes&token="+this.token+"&obj="+JSON.stringify(objEnvio), "_blank");
    }
    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
